var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgExitIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "36px",
    viewBox: "0 0 35 36",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Settings-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-Settings",
    transform: "translate(-469.000000, -792.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(469.000000, 792.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,4 C0,1.79086 1.79086,0 4,0 L31,0 C33.2091,0 35,1.79086 35,4 L35,32 C35,34.2091 33.2091,36 31,36 L4,36 C1.79086,36 0,34.2091 0,32 L0,4 Z",
    id: "Path",
    fillOpacity: 0.5,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2188,24.8125 L24.8438,24.2188 C24.9688,24.0625 24.9688,23.8125 24.8438,23.6875 L19.1875,18 L24.8438,12.3438 C24.9688,12.2188 24.9688,11.9688 24.8438,11.8125 L24.2188,11.2188 C24.0625,11.0625 23.8438,11.0625 23.6875,11.2188 L17.125,17.75 C17,17.9062 17,18.125 17.125,18.2812 L23.6875,24.8125 C23.8438,24.9688 24.0625,24.9688 24.2188,24.8125 Z",
    id: "Path",
    fill: "#3B3B3B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7187,11.1172 L11.0937,11.7109 C10.9687,11.8672 10.9687,12.1172 11.0937,12.2422 L16.75,17.9297 L11.0937,23.5859 C10.9687,23.7109 10.9687,23.9609 11.0937,24.1172 L11.7187,24.7109 C11.875,24.8672 12.0938,24.8672 12.25,24.7109 L18.8125,18.1797 C18.9375,18.0234 18.9375,17.8047 18.8125,17.6484 L12.25,11.1172 C12.0937,10.9609 11.875,10.9609 11.7187,11.1172 Z",
    id: "Path",
    fill: "#3B3B3B",
    fillRule: "nonzero"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExitIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/exit-icon.e1fbbd73.svg";
export { ForwardRef as ReactComponent };